import React, { useMemo, useState } from 'react'
import { Navigation, A11y } from 'swiper'
import { BrandMapping } from '@nsw-paginas-deslogadas/assets'
import { useAppContext } from '@nsw-paginas-deslogadas/store'
import { SystemBoldChevronleft, SystemBoldChevronright } from '@dasa-health/icons'
import { Icon } from '@dasa-health/components-react'
import { Swiper, SwiperSlide } from 'swiper/react'
import CardExam from './../CardExam'
import 'swiper/css'
import 'swiper/css/navigation'
import * as S from './styles'

const Swipper: React.FC = () => {
    const { brand } = useAppContext()
    const map = BrandMapping[brand.mappingId]
    const [navigationBtn, setNavigationBtn] = useState(false)

    const slidesLength = useMemo(() => {
        if (map.carousel.length >= 5) setNavigationBtn(true)
        if (map.carousel.length >= 4) return 4
        return map.carousel.length
    }, [map.carousel])

    return (
        <S.Content data-testid="swipper-testID">
            <S.Title>Agendamento online no {brand.name}</S.Title>
            <S.ContentSwiper cardsLength={map.carousel.length >= 5 ? '145px' : 0} centerCards={slidesLength <= 4 ? 'center' : ''}>
                {navigationBtn && (
                    <Icon className="prev-btn" id="prev-button">
                        <SystemBoldChevronleft />
                    </Icon>
                )}

                <Swiper
                    breakpoints={{
                        360: {
                            slidesPerView: 2,
                            grabCursor: true,
                            centeredSlides: true,
                            spaceBetween: 200,
                        },
                        744: {
                            slidesPerView: 2.5,
                        },
                        1024: {
                            slidesPerView: 4,
                            grabCursor: true,
                        },
                    }}
                    className="mySwiper"
                    modules={[Navigation, A11y]}
                    navigation={{
                        nextEl: '#next-button',
                        prevEl: '#prev-button',
                    }}
                    slidesPerView={slidesLength}
                    style={{ alignItems: slidesLength <= 3 ? 'center' : '' }}
                >
                    {map.carousel.map((item, index) => (
                        <SwiperSlide key={index}>
                            <CardExam
                                brandId={brand.id}
                                brandMapping={brand.mappingId}
                                button={item.button}
                                exams={item.exams}
                                image={item.image}
                                key={index}
                                title={item.title}
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
                {navigationBtn && (
                    <Icon className="prev-btn" id="next-button">
                        <SystemBoldChevronright />
                    </Icon>
                )}
            </S.ContentSwiper>
        </S.Content>
    )
}

export default Swipper
